
import { Link } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const Footer = () => {
    
  const { t } = useAppTranslation();

    return (
        <footer>
            <div className="container">
                {/* <!-- reg boshi --> */}
            <div className="register__box">
                <div className="register__contents">
                    <p className="register__title">{t('footerTitle')}</p>
                    <p className="register__text">{t('FooterSubtitle')}</p>
                    <Link className="register__btn" to="/courses">{t('footerBtn')}</Link>
                </div>
            </div>
            {/* <!-- reg oxiri -->
            <!-- SECTION BOSHI --> */}
            {/* <div className="section1">
                <div className="footer__directions">
                    <p className="direction__title">Directions</p>
                    <div className="direct__contents">
                        <p className="direct__link">Programming</p>
                        <p className="direct__link">Design</p>
                        <p className="direct__link">Marketing</p>
                        <p className="direct__link">Finance</p>
                        <p className="direct__link">All courses</p>
                    </div>
                </div>

                <div className="footer__directions">
                    <p className="direction__title">About Nuvix</p>
                    <div className="direct__contents">
                        <p><Link className="direct__link" to="/courses">Courses</Link></p>
                        <p><Link className="direct__link" to="/about">About us</Link></p>
                    
                        <p className="direct__link">Students</p>
                        <p className="direct__link">Career Center</p>
                        <p className="direct__link">Find an employee</p>
                        <p className="direct__link">Reviews</p>
                        <p className="direct__link">Nuvix Community</p>
                    </div>
                </div>

                <div className="footer__directions">
                    <p className="direction__title">Projects</p>
                    <div className="direct__contents">
                        <p className="direct__link">Webinars</p>
                        <p className="direct__link">Media</p>
                        <p className="direct__link">Sale</p>
                        <p className="direct__link">Free courses</p>
                    </div>
                </div>

                <div className="footer__directions">
                    <p className="direction__title">Cooperation</p>
                    <div className="direct__contents">
                        <p className="direct__link">Discounts for friends</p>
                        <p className="direct__link">For employers</p>
                        <p className="direct__link">Social projects</p>
                        <p className="direct__link">Bran materials</p>
                    </div>
                </div>
            </div> */}
            {/* <!-- SECTION1 OXIRI -->
            <!-- SECTION2 BOSHI --> */}
            <div className="section2">
                <div className="tels">
                    <div className="tel1">
                        <p className="tel">{t('tel1')}</p>
                    </div>
                </div>

                <div className="tels jce">
                    <p className="tel">{t('mail')}</p>
                </div>

                <div className="locate__plus">
                    <div className="location">
                        <p className="locate">{t('address')}</p>
                    </div>
                    <div className="social">
                        <a href={t('fLink')} target="_blank" rel="noopener noreferrer"><i className='bx bxl-facebook' style={{color: '#000'}} ></i></a>
                        <a href={t('tLink')} target="_blank" rel="noopener noreferrer"><i className='bx bxl-telegram' style={{color: '#000'}} ></i></a>
                        <a href={t('yLink')} target="_blank" rel="noopener noreferrer"><i className='bx bxl-youtube' style={{color: '#000'}} ></i></a>
                    </div>
                </div>
            </div>
            {/* <!-- SECTION2 OXIRI -->
            <!-- SECTION3 BOSHI --> */}
            <div className="section3">
                <p className="legal">{t('footerLegal')}</p>
                <div className="information">
                    <p className="part">{t('footerPart1')} <span>{t('footerPart2')}</span> {t('footerPart3')}</p>
                </div>
            </div>
                {/* <!-- SECTION3 OXIRI --> */}
                <div className="footer">
                    <p className="copy">&copy; {t('footerCopy')}</p>
                </div>

            </div>
        </footer>
    )



}